import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterProductGimmickCreatePage } from './master-product-gimmick-create.page';

const routes: Routes = [
  {
    path: '',
    component: MasterProductGimmickCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterProductGimmickCreatePageRoutingModule {}
